import { useService } from 'react-reservice';

import statisticsService from './service';

export const useStatistics = () => {
  return useService(statisticsService, (state) => state);
};

export { statisticsService };
